import { createSlice } from "@reduxjs/toolkit";

export default createSlice({
    name: "isSwell",
    initialState: false,
    reducers: {
        set: (state, action) => action.payload,
    },
});
